import { css } from 'styled-components';
import { colors } from '../../styles/colors';

export const filteredSearchedData = (selectVal, inputVal, arr = [], exactMatch = false) => {
  const newDataList = [];

  arr.forEach((obj) => {
    if (obj.class !== selectVal) {
      let newChildrenList = [];
      let modifiedObj = { ...obj };
      newChildrenList = filteredSearchedData(selectVal, inputVal, obj.children, exactMatch);
      if (newChildrenList.length > 0) {
        modifiedObj.children = newChildrenList;
        newDataList.push(modifiedObj);
      }
    }
    if (obj.class === selectVal) {
      const isMatch = exactMatch
        ? (obj.item || '').toLowerCase() === inputVal.toLowerCase()
        : (obj.item || '').toLowerCase().includes(inputVal.toLowerCase());
      if (isMatch) {
        newDataList.push({ ...obj });
      }
    }
  });
  return newDataList;
};

export const getLowestKeys = (record) => {
  let keys = [];

  if (record.children) {
    record.children.forEach((child_record) => {
      let child_key = getLowestKeys(child_record);
      keys.push(...child_key); // this will always be the key of the lowest heirarchy
    });
  } else {
    // only push key IF is the lowest level in hierarchy
    keys.push(record.key);
  }

  return keys;
};

export const AssociationsSelectorCss = (isMobile) => {
  return css`
    .ant-checkbox-inner {
      height: ${isMobile ? '24px' : '16px'};
      width: ${isMobile ? '24px' : '16px'};
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${colors['indigo']['7']};
      border-color: ${colors['indigo']['7']};
      outline-color: ${colors['indigo']['7']};
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${colors['indigo']['7']};
    }

    .ant-checkbox-indeterminate .ant-checkbox-inner::after {
      background-color: ${colors['indigo']['7']};
      width: ${isMobile ? '14px' : '8px'};
      height: ${isMobile ? '14px' : '8px'};
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
      left: ${isMobile ? '27%' : '21.5%'};
      transform: ${isMobile
        ? 'rotate(45deg) scale(1.25) translate(-50%, -50%)'
        : 'rotate(45deg) scale(1) translate(-50%, -50%)'};
    }

    .ant-table table {
      table-layout: auto !important;
      font-size: ${isMobile ? '16px' : '14px'};
    }

    .ant-table-row-indent + .ant-table-row-expand-icon {
      margin-top: ${isMobile ? '0px' : '2.5005px'};
    }

    .ant-table-row-expand-icon,
    .ant-table-row-expand-icon:focus,
    .ant-table-row-expand-icon:hover {
      color: ${colors['indigo']['7']};
      width: ${isMobile ? '24px' : '17px'};
      height: ${isMobile ? '24px' : '17px'};
      border-radius: 0px !important;
    }

    .ant-table-row-expand-icon:after {
      left: ${isMobile ? '10px' : '7px'};
    }

    .ant-table-row-expand-icon:before {
      top: ${isMobile ? '10px' : '7px'};
    }

    .ant-table-tbody > tr.ant-table-row:hover > td,
    .ant-table-tbody > tr > td.ant-table-cell-row-hover {
      background: none;
    }

    .ant-table-tbody > tr.ant-table-row-selected > td {
      background-color: none;
    }

    .ant-table-tbody > tr.ant-table-row-selected:hover > td {
      background: none;
    }

    .ant-table-thead > tr > th {
      background: none;
      border-bottom: 1px solid ${colors['gray']['2']};
    }

    .ant-table-tbody > tr > td {
      background: none;
      border-bottom: 1px solid ${colors['gray']['2']};
    }

    .ant-table-tbody > tr.ant-table-row-selected > td {
      background: none;
      border-color: none;
    }

    .ant-btn-group .ant-btn-primary:first-child:not(:last-child) {
      border-right-color: transparent;
    }

    li.ant-dropdown-menu-item.ant-dropdown-menu-item-selected {
      color: rgba(0, 0, 0, 0.85);
      background-color: transparent;
    }

    button.ant-btn.ant-btn-primary.ant-btn-sm {
      color: ${colors['indigo']['7']};
      border: none;
      text-shadow: none;
      box-shadow: none;
      background: transparent;
    }

    button.ant-btn.ant-btn-link.ant-btn-sm {
      color: ${colors['indigo']['7']};
      border: none;
      text-shadow: none;
      box-shadow: none;
      background: transparent;
    }

    span.ant-dropdown-trigger.ant-table-filter-trigger.active {
      color: ${colors['indigo']['7']};
    }

    span.anticon.anticon-caret-up.ant-table-column-sorter-up.active {
      color: ${colors['indigo']['7']};
    }

    span.anticon.anticon-caret-down.ant-table-column-sorter-down.active {
      color: ${colors['indigo']['7']};
    }

    div.ant-select-item.ant-select-item-option.ant-select-item-option-active.ant-select-item-option-selected {
      background-color: transparent;
    }

    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: transparent;
    }
  `;
};
